import * as types from './mutation_types'

export const setDetail = ({ commit }, detail) => commit(types.SET_DETAIL, detail)
export const toggleShowDetail = ({ commit }) => commit(types.TOGGLE_SHOW_DETAIL)
export const resetState = ({ commit }) => commit(types.RESET_STATE)
export const setFilter = ({ commit }, nextPage) => commit(types.SET_FILTER, nextPage)
export const setFilterField = ({ commit }, filterCategory) => commit(types.SET_FILTER_FIELD, filterCategory) 
export const setQuery = ({ commit }, query ) => commit(types.SET_QUERY, query)
export const toggleModalFetch = ({ commit }) => commit(types.TOGGLE_MODAL_FETCH)
export const addFilter = ({ commit}, filter) => commit(types.ADD_FILTER, filter)
export const pushFilter = ({ commit }, filter) => commit(types.PUSH_FILTER, filter)
export const addAllFilter = ({ commit }, filter) => commit(types.ADD_ALL_FILTER, filter)
export const resetAllFilter = ({ commit }) => commit(types.RESET_ALL_FILTER)
export const setManualFilter = ({ commit}, filter ) => commit(types.SET_MANUAL_FILTER, filter)